import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=c8696cac&"
import script from "../account.js?vue&type=script&lang=js&"
export * from "../account.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports